import styled from '@emotion/styled';

import colors from '$variables/colors';
import { spacing } from '$variables/theme';

export const Container = styled.div`
  height: 48px;
  padding: ${spacing.xSmall} 0;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  & > * {
    margin-top: ${spacing.xSmall};
  }

  & div:first-of-type {
    margin-top: 0px;
  }
`;

export const GradeLabel = styled.div`
  padding: 0 ${spacing.xxSmall};

  line-height: 20px;
  background-color: ${colors.shadow2};
  border-radius: 4px;
`;
